import SantaShopTemplate from "../../components/santaShop/SantaShopTemplate";

const SantaShopPage = () => {
  return (
    <>
      <SantaShopTemplate/>
    </>
  );
};

export default SantaShopPage;